<template xmlns="http://www.w3.org/1999/html">
    <tr>
        <td><span @click="$router.push({ name: 'ProjectTabInvoicesPayments', params: { id: projectId }});" class="action">{{projects[projectId].name}}</span></td>
        <td class="currency">{{Math.round(revenue/100)}}</td>
        <td class="currency">{{Math.round(projects[projectId].baseline_costs)}}</td>
        <td class="currency">{{Math.round(actuals[projectId]/100)}}</td>
        <td class="currency">{{Math.round(projectMaterialCost.total/100)}}</td>
        <td class="currency">{{Math.round(etc[projectId])}}</td>
        <td class="currency">{{Math.round(eac/100)}}</td>
        <td>{{((projects[projectId].baseline_costs*100)/eac).toFixed(2)}}</td>
        <td class="currency">{{Math.round((revenue - eac)/100)}}</td>
    </tr>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'ProjectFinancesRow',
  props: { projectId: '' },
  components: {
  },
  computed: {
    ...mapGetters('JiraProjects', ['projects']),
    ...mapGetters('IncomingPayments', ['incomingPayments']),
    ...mapGetters('UserRates', ['ratesOnDate']),
    ...mapGetters('Worklogs', ['worklogsByProject']),
    ...mapGetters('ProjectFinances', ['actuals', 'materials', 'etc']),
    ...mapGetters('ProjectMaterials', ['projectMaterialsByProject']),
    ...mapGetters('Clients', ['projectRevenue']),
    revenue() {
      if (!this.projectRevenue[this.projectId]) return 0;
      return this.projectRevenue[this.projectId];
    },
    projectMaterialCost() {
      const materialCost = {
        total: 0,
        materials: []
      };
      for (const materialId in this.materials) {
        const material = this.materials[materialId];
        if (material.project_id == this.projectId) {
          materialCost.total += parseInt(material.cost);
          materialCost.materials.push(material);
        }
      }
      return materialCost;
    },
    eac() {
      return (this.etc[this.projectId] * 100) + this.projectMaterialCost.total + this.actuals[this.projectId];
    }
  },
  methods: {
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
    .currency::before{
        content: "€";
    }
    tr td:not(:first-child){
        text-align: right;
    }
    td {
        padding: 0;
    }
    .action {
    margin-left: 5px;

    &:hover {
      cursor: pointer;
      color: #ee0044;
    }
  }
</style>
